import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { deleteUserAPI } from '../../services/settings';
import store from '../../states';

import Button from '../widgets/button';

export default ({ api, onHide, show, id }: any) => {
  // console.log('asfdjaisjo', id);
  const [glossary, sGlossary] = useState<any>({});
  useEffect(() => {
    sGlossary(store.getState());
    const unsubscribe = store.subscribe(() => {
      sGlossary(store.getState());
    });
    return () => unsubscribe();
  }, []);

  const deleteUser = (id: number) => {
    const payload = {
      user_id: id,
    };
    deleteUserAPI(payload)
      .then(() => {
        // if (fn) fn();
        api();
      })
      .catch(() => {
        //
      });
  };

  return (
    <Modal onHide={onHide} show={show} centered size={'lg'}>
      <Modal.Header>
        <h2 style={{ margin: 10 }}>{glossary.setting_user_remove_popup_title}</h2>
      </Modal.Header>
      <Modal.Body style={{ padding: '40px' }}>
        {glossary.setting_user_remove_popup_instruction}
      </Modal.Body>
      <Modal.Footer>
        <Button
          kind={'secondary'}
          text={glossary.setting_user_remove_popup_button_cancel}
          click={() => {
            onHide();
          }}
        />
        <Button
          kind={'primary'}
          text={glossary.setting_user_remove_popup_button_delete}
          click={() => {
            // api();
            deleteUser(id);
            onHide();
          }}
        />
      </Modal.Footer>
    </Modal>
  );
};
